import React from "react";
import {
  Button,
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
  MenuItem,
  MenuList,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "../Avatar/Avatar";
import { Link } from "react-router-dom";
import { injectIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Auth from "../../../utils/Auth";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  paper: {
    marginRight: theme.spacing(2),
  },
}));

function DropDownMenu(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const { messages } = props.intl;
  const lang = useSelector((state) => state.locale.lang);
  const ListArr = [
    // {
    //   id: 1,
    //   name: "Profile",
    //   link: "/agentProfile",
    // },
    {
      id: 2,
      name: messages.auth.changePassword,
      link: "/admin/dashboard/changePassword",
    },
    {
      id: 3,
      name: messages.auth.logout,
      link: "/admin/dashboard/login",
    },
  ];
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event, linkId) => {
    linkId === 3 && Auth.logout();
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  const renderDropDownList = (listArr) => {
    return listArr.map((item) => {
      return (
        <Link to={item.link} key={item.name}>
          <MenuItem
            className={
              lang === "ar"
                ? "text-right medium_font text-dark"
                : "text-left medium_font text-dark"
            }
            dir={lang === "ar" ? "rtl" : "ltr"}
            onClick={(event) => handleClose(event, item.id)}
          >
            {item.name}
          </MenuItem>
        </Link>
      );
    });
  };

  return (
    <div className={classes.root}>
      <div style={{ zIndex: 999 }}>
        <Button
          className="text-white"
          ref={anchorRef}
          aria-controls={open ? "menu-list-grow" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <Avatar
            color={true}
            name={
              localStorage.getItem("first_name") &&
              localStorage.getItem("first_name")
            }
          />
          <KeyboardArrowDownIcon />
        </Button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="menu-list-grow"
                    onKeyDown={handleListKeyDown}
                  >
                    {renderDropDownList(ListArr)}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </div>
  );
}

const DropDownMenuComponent = injectIntl(DropDownMenu);

export default DropDownMenuComponent;
